// Service che genera e verifica le firme xml. Le firme sono generate attraverso dei
// template presenti in TemplateHelpers e TemplateHelpersNewAlg

import forge from "node-forge";
import { blind, unblind, verify } from "./BlindLogic";

import { getVoteToSign, castVoteTemplateBuilder } from "./TemplateHelpers";

import {
  getSignedProperties,
  getKeyInfo,
  getSignedInfo,
  getSignatureTemplate
} from "../../src/services/TemplateHelpersNewAlg";

import {
  sha256Digest,
  encodeASN256,
  getCertificateSHA256,
  getIssuerName
} from "../../src/services/cryptoUtils";

class EncryptionService {
  electionCert;
  electionCertStr;
  countingCert;
  countingCertStr;

  constructor(ceoCbbService, electionCert, countingCert) {
    this.ceoCbbService = ceoCbbService;
    this.electionCert = forge.pki.certificateFromPem(
      "-----BEGIN CERTIFICATE-----" + electionCert + "-----END CERTIFICATE-----"
    );
    this.electionCertStr = electionCert;

    this.countingCert = forge.pki.certificateFromPem(
      "-----BEGIN CERTIFICATE-----" + countingCert + "-----END CERTIFICATE-----"
    );
    this.countingCertStr = countingCert;
  }
  async sendVote(
    eventIdentifier,
    electionIdentifier,
    voterIdentifier,
    candidates,
    affiliations,
    NoChoiceIdentifier,
    NullChoiceIdentifier
  ) {
    let castVote = castVoteTemplateBuilder(
      eventIdentifier,
      electionIdentifier,
      candidates,
      affiliations,
      NoChoiceIdentifier,
      NullChoiceIdentifier
    );

    let symmetricKey = forge.random.getBytesSync(16);
    let keyEncryptKey = this.countingCert.publicKey;
    let encryptedSymmetricKey = keyEncryptKey.encrypt(
      symmetricKey,
      "RSAES-PKCS1-V1_5"
    );
    let cipher = forge.cipher.createCipher("AES-CBC", symmetricKey);
    let iv = forge.random.getBytesSync(16); //Entropy
    cipher.start({ iv: iv });
    cipher.update(forge.util.createBuffer(castVote, "utf8"));
    cipher.finish();
    let encryptedCastVote = cipher.output.getBytes();
    const template = getVoteToSign(
      forge.util.encode64(encryptedCastVote),
      forge.util.encode64(encryptedSymmetricKey),
      electionIdentifier.Id
    );
    const hash = forge.util.encode64(
      sha256Digest(template)
        .digest()
        .getBytes()
    );
    let certificateDigest = getCertificateSHA256(this.electionCert);
    const serialNumber = parseInt("0x" + this.electionCert.serialNumber);
    const issuerName = getIssuerName(this.electionCert);

    let signedProperties = getSignedProperties(
      serialNumber,
      issuerName,
      certificateDigest
    );
    let signedPropertiesDigest = forge.util.encode64(
      sha256Digest(signedProperties)
        .digest()
        .getBytes()
    );

    let keyInfo = getKeyInfo(this.electionCertStr);
    let keyInfoDigest = forge.util.encode64(
      sha256Digest(keyInfo)
        .digest()
        .getBytes()
    );

    const signedInfo = getSignedInfo(
      hash,
      signedPropertiesDigest,
      keyInfoDigest
    );
    let asn256Encoded = encodeASN256(signedInfo, this.electionCert.publicKey);

    let encodedBlindedSignedInfoHashBundle = blind({
      message: asn256Encoded,
      N: this.electionCert.publicKey.n,
      E: this.electionCert.publicKey.e,
      // blindFactor: "test",
      inputType: "hex"
    });

    let encodedBlindedSignedInfoHash =
      encodedBlindedSignedInfoHashBundle.blinded;
    let r = encodedBlindedSignedInfoHashBundle.r;

    // let signed = await this.ceoCbbService.getBallotSignature({
    //   ToSignValue: encodedBlindedSignedInfoHash
    // }).SignedValue;
    let bsr = this.createBallotSignatureRequest(
      eventIdentifier,
      electionIdentifier,
      voterIdentifier,
      encodedBlindedSignedInfoHash
    );
    let response = await this.ceoCbbService.getBallotSignature(bsr);

    if (response.error) {
      alert(
        response.error +
          "\n\nVerificare i contatti del supporto sulle pagine informative del proprio Ente"
      );
      return;
    }

    let ballotToken = response.BallotToken;
    let signed = response.SignedValue;
    let unblindedSignedValue = unblind({
      signed: signed,
      r: r,
      N: this.electionCert.publicKey.n
    });

    let transId = "1";

    //APOLLO: PARTE AGGIUNTA PER IL PROBLEMA DELLA LUNGHEZZA DELL'UNBLINDED CHE CIRCA IN UN CASO SU 200
    //PUÒ ESSERE DI LUNGHEZZA 127. IN QUESTO CASO IL VALORE NON VIENE ACCETTATO DA JAVA > 6.
    //PERCIÒ DEVE ESSERE AGGIUNTO IL PADDING DI UNO 0 (ZERO) INIZIALE
    let unblindedSignedValueDecode64 = forge.util.decode64(
      unblindedSignedValue
    );

    if (unblindedSignedValueDecode64.length == 127) {
      var buffer = new Buffer.from(unblindedSignedValueDecode64, "ascii");
      var paddedBuffer = [];

      //aggiunge lo 0 iniziale all'unblinded
      paddedBuffer.push(0);
      for (var j = 0; j < buffer.length; j++) {
        paddedBuffer.push(buffer[j]);
      }

      let paddedUnblindedSignedValueDecoded64 = "";
      for (var k = 0; k < paddedBuffer.length; k++) {
        paddedUnblindedSignedValueDecoded64 += String.fromCharCode(
          paddedBuffer[k]
        );
      }

      //assegna il nuovo valore con 0 iniziale all'unblinded che sta elaborando
      unblindedSignedValue = forge.util.encode64(
        paddedUnblindedSignedValueDecoded64
      );

      transId = "2";
    }
    //APOLLO: FINE DELLA MODIFICA

    let result = verify({
      unblinded: unblindedSignedValue,
      message: asn256Encoded,
      N: this.electionCert.publicKey.n,
      E: this.electionCert.publicKey.e,
      inputType: "hex"
    });
    if (!result) {
      alert(
        "Verifica firma fallita.\n\nVerificare i contatti del supporto sulle pagine informative del proprio Ente"
      );
      return;
    }
    let xml = getSignatureTemplate(
      signedInfo,
      template,
      certificateDigest,
      issuerName,
      serialNumber,
      unblindedSignedValue,
      this.electionCertStr
    );
    let btbResponse = await this.ceoCbbService.ballotToBallotBox(
      ballotToken,
      forge.util.encode64(xml),
      transId
    );
    return btbResponse.Accepted;
  }

  createBallotSignatureRequest(
    eventIdentifier,
    electionIdentifier,
    voterIdentifier,
    blindedEncryptedBallotDigest
  ) {
    let ballotSignatureRequest = {};
    ballotSignatureRequest.Channel = this.getChannel(eventIdentifier.Id);
    ballotSignatureRequest.ElectionIdentifier = electionIdentifier;
    ballotSignatureRequest.VoterIdentifier = voterIdentifier;
    ballotSignatureRequest.eventId = eventIdentifier.Id;
    ballotSignatureRequest.voterId = voterIdentifier.VoterId[0];
    ballotSignatureRequest.ToSignValue = blindedEncryptedBallotDigest;
    return ballotSignatureRequest;
  }

  getChannel(eventId) {
    return {
      Type: "KVC", // TODO: Altri canali???
      Id: "KVC",
      AuthenticationMethod: "USERNAME-PASSWORD",
      EventIdentifier: {
        Id: eventId
      }
    };
  }

  encryptBallot(castVote, electionId) {
    let symmetricKey = forge.random.getBytesSync(16);
    let keyEncryptKey = this.countingCert.publicKey;
    let encryptedSymmetricKey = keyEncryptKey.encrypt(
      symmetricKey,
      "RSAES-PKCS1-V1_5"
    );
    let cipher = forge.cipher.createCipher("AES-CBC", symmetricKey);
    let iv = forge.random.getBytesSync(16); //Entropy
    cipher.start({ iv: iv });
    cipher.update(forge.util.createBuffer(castVote, "utf8"));
    cipher.finish();
    let encryptedBallot = cipher.output.getBytes();
    let voteToSign = getVoteToSign(
      forge.util.encode64(encryptedBallot),
      forge.util.encode64(encryptedSymmetricKey),
      electionId
    );

    let signedInfo = getSignedInfo(
      forge.util.encode64(
        sha256Digest(voteToSign)
          .digest()
          .getBytes()
      )
    );
    return {
      signedInfo: signedInfo,
      voteToSign: voteToSign
    };
  }
  // questa verifica fallisce perché la firma è raw
  verifyCeoSignature(message, signedValue) {
    let hash = sha256Digest(message)
      .digest()
      .getBytes();
    let verified = this.electionCert.publicKey.verify(
      hash,
      forge.util.decode64(signedValue),
      "RSASSA-PKCS1-V1_5"
    );
    return verified;
  }
}

export default EncryptionService;
